application.register("layout_footer", class extends Stimulus.Controller {
    scrollTop() {
        document.documentElement.scroll({top: 0, behavior: 'smooth'});
    }
});
